import $ from 'jquery';

export default class FAQSection {
    constructor() {
        $('.sechomefaq__answer').first().toggleClass('sechomefaq__active');
        $('.sechomefaq__icon').first().toggleClass('sechomefaq__active-icon');
        $('.sechomefaq__wrapper-question').on('click', function () {
            $(this).toggleClass('sechomefaq__inactive');
            var sectionIndex = $(this).attr('id').replace(/[A-Za-z]+-/,'').replace(/__[A-Za-z]+-\d/,'');
            var bookmarkIndex = $(this).attr('id').replace(/[A-Za-z]+-\d__[A-Za-z]+-/, '');
            $('.sechomefaq__answer').removeClass('sechomefaq__active');
            $('.sechomefaq__icon').removeClass('sechomefaq__active-icon');
            $('#sechomefaq-'+sectionIndex+'__answer-'+bookmarkIndex).toggleClass('sechomefaq__active');
            $('#sechomefaq-'+sectionIndex+'__icon-'+bookmarkIndex).toggleClass('sechomefaq__active-icon');
        });
    }
}
